import request from '@/util/request'

// 获取路由
export const getRouters = () => {
  return request({
    url: '/api-admin/permission/routes',
    method: 'get',
    headers: {
      isToken: true
    },
  })
}
